module.exports = __webpack_public_path__ + "img/hd2.05d58d0b.png";